import { defineMasterdataEntity } from '../types/masterdata-entity-definition';
import { MasterdataProject } from '../types/masterdata-entities';
import { keyName } from './shared';

export const MASTERDATA_PROJECT = defineMasterdataEntity<MasterdataProject>({
  name: 'project',
  responseKey: 'projects',
  displayWith: (p) => keyName(p.key, p.name),
  secondaryWith: (p) => p.description ?? p.customer?.shortName ?? null,
  icon: 'fa-regular fa-diagram-project',
  title: 'Objekt-/Projektsuche',
  label: 'Objekt/Projekt',
  placeholder: 'Objekt/Projekt suchen...',
  columns: [
    {
      label: 'Objekt/Projekt',
      type: 'entity',
      icon: 'fa-regular fa-diagram-project',
      value: (e) => keyName(e.key, e.name),
      secondary: (e) => e.description ?? e.customer?.shortName ?? null,
    },
    { label: 'Schlüssel', type: 'text', value: (e) => e.key },
    { label: 'Bezeichnung', type: 'text', value: (e) => e.name },
    { label: 'Beschreibung', type: 'text', value: (e) => e.description },
    { label: 'Status', type: 'text', value: (e) => e.status },
    { label: 'Art', type: 'text', value: (e) => e.type },
    {
      label: 'Abrechnung Ist',
      type: 'text',
      value: (e) => e.actualsBilling?.name ?? null,
    },
    {
      label: 'Vertriebsniederlassung',
      type: 'text',
      value: (e) => e.salesBranch?.name ?? null,
    },
    { label: 'Kunde', type: 'text', value: (e) => e.customer?.shortName ?? null },
    {
      label: 'Rechnungskunde',
      type: 'text',
      value: (e) => e.billingCustomer?.shortName ?? null,
    },
    { label: 'Gruppe', type: 'text', value: (e) => e.group?.name ?? null },
    { label: 'Sparte', type: 'text', value: (e) => e.division?.name ?? null },
    {
      label: 'Kostenstellen',
      type: 'text',
      value: (e) => e.costCenters?.join(', ') ?? null,
    },
  ],
});
